import { allowsPartialGeosetFile, isGeosetGeoJSON } from './geoset-file-policy';
import { isEmptyString } from '@/utils/string';

async function checkOnMainThread(file: File): Promise<boolean> {
  try {
    return allowsPartialGeosetFile(file.name, await file.text());
  } catch {
    return false;
  }
}

// Geoset uploads can reach 64 MB. Keep JSON parsing off the UI thread.
export async function canSkipInvalidGeosetRows(file: File): Promise<boolean> {
  try {
    const prefix = await file.slice(0, 1024).text();
    if (!isEmptyString(prefix) && !isGeosetGeoJSON(file.name, prefix)) return true;
  } catch {
    return false;
  }
  if (typeof Worker === 'undefined') return checkOnMainThread(file);
  let worker: Worker;
  try {
    worker = new Worker(new URL('./check-geoset-file.worker.ts', import.meta.url), { type: 'module' });
  } catch {
    return checkOnMainThread(file);
  }
  try {
    return await new Promise<boolean>((resolve) => {
      const timeout = setTimeout(() => finish(false), 30_000);
      function finish(canSkip: boolean) {
        clearTimeout(timeout);
        resolve(canSkip);
      }
      worker.onmessage = (event: MessageEvent<boolean>) => finish(event.data === true);
      worker.onerror = () => finish(false);
      worker.onmessageerror = () => finish(false);
      try {
        worker.postMessage(file);
      } catch {
        finish(false);
      }
    });
  } finally {
    worker.terminate();
  }
}
